import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Tile, TileSector, TileSegment } from 'web-ui-components/lib/molecules/tile';
import { List } from 'web-ui-components/lib/atoms/text';
import withContent from '../../../containers/withContent';
import content, { contentPropTypes } from './paymentLimitsModal.content';
import { getShowDailyLimitModal, getDailyLimitModalDates } from '../../../states/payments/selectors';
import { resetDailyLimitAuthorisation } from '../../../states/payments/actions';
import { resetApp } from '../../../states/page/actions';
import { getIFTPayments, getIsEditing } from '../../../states/ift/selectors';
import {
	unauthorisedTransactionLimitFilter,
	unauthorisedDailyLimitFilter,
} from '../../../states/commonSelectors/selectors';

const mapState = (state) => ({
	show: getShowDailyLimitModal(state),
	dateList: getDailyLimitModalDates(state),
	isTransactionLimitError: getIFTPayments(state).some(unauthorisedTransactionLimitFilter),
	isDailyLimitError: getIFTPayments(state).some(unauthorisedDailyLimitFilter),
	isEditing: getIsEditing(state),
});

const mapDispatch = (dispatch) => ({
	onCancel: () => dispatch(resetApp),
	onClose: () => dispatch(resetDailyLimitAuthorisation()),
});

const getMessage = ({ showPluralMessage, isEditing, isDailyLimitError, isTransactionLimitError, content }) => {
	const { pluralMessage, singularMessage, editIFTDailyLimitMessage, editIFTTransactionLimitMessage } = content;
	if (isEditing && isDailyLimitError) return editIFTDailyLimitMessage;
	if (isEditing && isTransactionLimitError) return editIFTTransactionLimitMessage;
	return showPluralMessage ? pluralMessage : singularMessage;
};

const PaymentLimitsModal = ({
	content,
	show,
	onClose,
	onCancel,
	dateList,
	isEditing,
	isTransactionLimitError,
	isDailyLimitError,
}) => {
	const { title, transactionLimitTitle, confirmSinglePayment, confirm, reject } = content;
	const modalTitle = isEditing && isTransactionLimitError ? transactionLimitTitle : title;
	const showPluralMessage = dateList.length > 1;
	const message = getMessage({ showPluralMessage, isEditing, isDailyLimitError, isTransactionLimitError, content });
	const confirmText = isEditing ? confirmSinglePayment : confirm;
	return (
		<Modal isOpen={show} onRequestClose={onClose}>
			<Tile>
				<TileSector title={modalTitle}>
					<TileSegment data-testid="message" className="u-text-align-center">
						{message}
					</TileSegment>
					{!isEditing && (
						<TileSegment>
							<List items={dateList} />
						</TileSegment>
					)}
					<TileSegment>
						<Button size="md" display="primary" data-testid="confirm" className="u-flex-grow-0" onClick={onClose}>
							{confirmText}
						</Button>
					</TileSegment>
					<TileSegment>
						<Button size="md" data-testid="cancel" className="u-flex-grow-0" onClick={onCancel}>
							{reject}
						</Button>
					</TileSegment>
				</TileSector>
			</Tile>
		</Modal>
	);
};

PaymentLimitsModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	dateList: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		})
	).isRequired,
	isEditing: PropTypes.bool.isRequired,
	isTransactionLimitError: PropTypes.bool.isRequired,
	isDailyLimitError: PropTypes.bool.isRequired,
};

const contentWrapper = withContent({ content });
const connector = connect(mapState, mapDispatch);

export const ConnectWrapper = connector(PaymentLimitsModal);
export default compose(connector, contentWrapper)(PaymentLimitsModal);
export const PaymentLimits = withContent({ content })(PaymentLimitsModal);
